var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.module.resource.content)?_c('div',{staticStyle:{"text-align":"center"},style:({  display: '', justifyContent: _vm.align(_vm.module.style.align), alignItems: _vm.valign(_vm.module.style.valign) })},[_c('img',{staticStyle:{"max-height":"100%","max-width":"100%"},style:({
        border: _vm.module.resource.content.imageBorderSize + 'px solid',
        borderColor: _vm.module.resource.content.imageBorderColor,
        objectFit : 'contain'
      }),attrs:{"src":_vm.module.resource.content.imageUrl,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }